class ImageWithText extends HTMLElement {
  constructor() {
    super();
    this.images = null;
    this.productLinks = null;
    this.intervalId = null;
    this.currentIndex = 0;
    this.intervalTime = 2500;
  }

  connectedCallback() {
    this.images = this.querySelectorAll('[data-image-with-text-images]');
    this.productLinks = this.querySelectorAll(
      '[data-image-with-text-product-link]'
    );

    if (this.images.length <= 1) return;

    const intervalAttr = this.dataset.interval;
    if (intervalAttr) {
      this.intervalTime = Number(intervalAttr) || 2500;
    }

    this.startCycling();
  }

  disconnectedCallback() {
    this.stopCycling();
  }

  startCycling() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;

      this.images.forEach((img, index) => {
        if (index === this.currentIndex) {
          img.classList.add('opacity-100');
          img.classList.remove('opacity-0');
        } else {
          img.classList.remove('opacity-100');
          img.classList.add('opacity-0');
        }
      });

      this.productLinks.forEach((link, index) => {
        if (index === this.currentIndex) {
          link.classList.add('opacity-100');
          link.classList.remove('pointer-events-none');
          link.classList.add('pointer-events-auto');
          link.classList.remove('opacity-0');
        } else {
          link.classList.remove('opacity-100');
          link.classList.add('opacity-0');
          link.classList.remove('pointer-events-auto');
          link.classList.add('pointer-events-none');
        }
      });
    }, this.intervalTime);
  }

  stopCycling() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

if (!customElements.get('image-with-text')) {
  customElements.define('image-with-text', ImageWithText);
}
